import styles from "./collapse.module.css";
import arrow from "../../../images/arrow.svg";
import { useState } from "react";

function Collapse(props) {
  const [collapseExpanded, setCollapseExpanded] = useState(false);

  const handleCollapseExpanded = (e) => {
    setCollapseExpanded(!collapseExpanded);
    if (e.target.name === "collapse-arrow") {
      if (e.target.parentNode.nextElementSibling.style.maxHeight) {
        e.target.parentNode.nextElementSibling.style.maxHeight = null;
        return;
      }
      e.target.parentNode.nextElementSibling.style.maxHeight =
        e.target.parentNode.nextElementSibling.scrollHeight + "px";
      return;
    }
    if (e.target.nextElementSibling.style.maxHeight) {
      e.target.nextElementSibling.style.maxHeight = null;
      return;
    }
    e.target.nextElementSibling.style.maxHeight =
      e.target.nextElementSibling.scrollHeight + "px";
  };

  return (
    <div className={styles.collapse}>
      <div className={styles.collapseContainer}>
        <h3
          className={`${styles.collapseTitle}${
            collapseExpanded ? " " + styles.collapseExpanded : ""
          }`}
          onClick={handleCollapseExpanded}
        >
          {props.title}
          <img src={arrow} name="collapse-arrow" />
        </h3>
        <div className={`${styles.collapseContent}`}>
          <div>
            <p>
              {props.text}
              {props.children}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Collapse;
